import axios from 'axios';
import qs from 'qs';
import config from '../apiConfig';

/**
 * Return a promise for a guest customer Id. This can be used to save a shopping cart
 * and wish list on the server.
 * @param {axios cancel Token} cancelToken
 * @returns promise
 * This endpoint returns a JSON Web Token (JWT)
 */
const getGuestCustomer = cancelToken => {
	const instance = axios.create(config);

	return instance.get('GuestCustomer', {
		cancelToken,
	});
};

/**
 * Returns a promise for a login post request.
 * @param {axios cancellation token} cancelToken - cancel an ongoing request.
 * @param {object} user
 * The cancellation token can be generated using the helper function getCancellationToken
 * @returns promise
 * This endpoint returns a JSON Web Token (JWT)
 */
const login = (cancelToken, email, password) => {
	// Note: By default axios sets the body to be Json. Our endpoint wants this to be
	// form-urlencoded. The URLSearchParams API is the easiest way to do this but is not
	// supported by Edge yet or JSDOM for our unit tests. Since I had to include the qs
	// library for another situation I'm using it here.

	if (!email) {
		throw new Error('Login id is required.');
	}

	if (!password) {
		throw new Error('Password is required.');
	}

	const instance = axios.create(config);

	return instance.post(
		'login',
		qs.stringify({
			loginId: email,
			password,
		}),
		{
			cancelToken,
		},
	);
};

/**
 * Returns a promise for a registration POST request
 * @param {Axios cancel token} cancelToken
 * @param {string} email - username for eSTORIS
 * @param {string} password
 * @param {string} firstName
 * @param {string} lastName
 * @returns promise
 * This endpoint returns a JSON Web Token (JWT)
 */
const register = (cancelToken, email, password, firstName, lastName) => {
	if (!email) {
		throw new Error('Email address is required.');
	}

	if (!password) {
		throw new Error('Password is required.');
	}

	if (!firstName) {
		throw new Error('First name is required.');
	}

	if (!lastName) {
		throw new Error('Last name is required.');
	}

	const instance = axios.create(config);

	return instance.post(
		'Register',
		qs.stringify({
			email,
			password,
			firstName,
			lastName,
		}),
		{
			cancelToken,
		},
	);
};

export { getGuestCustomer, login, register };
